export default {
  path: '/material_states',
  name: 'material_states',
  component: () => import('../components/materialstate/Layout'),
  redirect: { name: 'MaterialStateList' },
  meta: {
    breadcrumb: 'profile.material.states',
  },
  children: [
    {
      name: 'MaterialStateList',
      path: '',
      component: () => import('../views/materialstate/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MaterialStateCreate',
      path: 'new',
      component: () => import('../views/materialstate/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MaterialStateUpdate',
      path: ':id/edit',
      component: () => import('../views/materialstate/Update'),
      meta: {
        breadcrumb: 'profile.material.state',
      },
    },
    {
      name: 'MaterialStateShow',
      path: ':id',
      component: () => import('../views/materialstate/Show'),
      meta: {
        breadcrumb: 'profile.material.state',
      },
    }
  ]
};
